import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Fluid } from 'primeng/fluid';
import { Textarea } from 'primeng/textarea';
import { Card } from 'primeng/card';
import { NgClass } from '@angular/common';

export const SONSTIGES_MAX_LENGTH: number = 2000;

@Component({
  selector: 'app-sonstiges[sonstiges]',
  imports: [ReactiveFormsModule, Fluid, Textarea, Card, NgClass],
  templateUrl: './sonstiges.component.html',
  styleUrl: './sonstiges.component.scss'
})
export class SonstigesComponent {
  @Input()
  public sonstiges!: FormControl<string | null>;

  protected readonly sonstigesMaxLength: number = SONSTIGES_MAX_LENGTH;
}
